interface DVLAVehicleResponse {
  registrationNumber: string;
  make: string;
  model: string;
  yearOfManufacture: number;
  fuelType: string;
  colour: string;
}

interface Vehicle {
  registrationNumber: string;
  make: string;
  model: string;
  yearOfManufacture: number;
  colour?: string;
  fuelType?: string;
}

// Validate UK registration number format
function validateRegistration(registration: string): string {
  const cleanReg = registration.toUpperCase().replace(/[^A-Z0-9]/g, '');
  
  if (!cleanReg.match(/^[A-Z0-9]{2,7}$/)) {
    throw new Error('Please enter a valid UK vehicle registration');
  }
  
  return cleanReg;
}

// Mock vehicle database for development
const mockVehicles: Record<string, DVLAVehicleResponse> = {
  'AB12CDE': {
    registrationNumber: 'AB12CDE',
    make: 'FORD',
    model: 'FOCUS',
    yearOfManufacture: 2020,
    fuelType: 'PETROL',
    colour: 'BLACK'
  },
  'XY58ABC': {
    registrationNumber: 'XY58ABC',
    make: 'VOLKSWAGEN',
    model: 'GOLF',
    yearOfManufacture: 2019,
    fuelType: 'DIESEL',
    colour: 'SILVER'
  }
};

export async function lookupVehicle(registration: string): Promise<Vehicle> {
  const cleanReg = validateRegistration(registration);
  
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 500));

  // Check mock database
  const mockVehicle = mockVehicles[cleanReg];

  if (mockVehicle) {
    return {
      registrationNumber: mockVehicle.registrationNumber,
      make: mockVehicle.make,
      model: mockVehicle.model,
      yearOfManufacture: mockVehicle.yearOfManufacture,
      colour: mockVehicle.colour,
      fuelType: mockVehicle.fuelType
    };
  }

  // For any other registration, return a generic vehicle
  return {
    registrationNumber: cleanReg,
    make: 'FORD',
    model: 'FOCUS',
    yearOfManufacture: 2020,
    colour: 'BLACK',
    fuelType: 'PETROL'
  }
}